const AGE_GATING_SUCCESS = 'frontend/age-gating/AGE_GATING';
const AGE_GATING_FAIL = 'frontend/age-gating/AGE_GATING';


export function ageGatingSuccess(dob) {
  return { type: AGE_GATING_SUCCESS, payload: { dob, success: true } };
}

export function ageGatingFail(dob) {
  return { type: AGE_GATING_FAIL, payload: { dob, success: false } };
}
